// extracted by mini-css-extract-plugin
export var wrapper = "section-main-image-module--wrapper--zULpq";
export var text = "section-main-image-module--text--1qvys";
export var imageWrapper = "section-main-image-module--image-wrapper--21Vbj";
export var image = "section-main-image-module--image--N5Ker";